import PropTypes from 'prop-types'
import React from 'react'
import StepNav from '../../shared/components/StepNav'

export default function ReleaseNav({
  onChange,
  section,
  steps,
  type,
}) {

  return (
    <div className={`${type} container`}>
      <div className="form form-horizontal">
        <StepNav
          active={section}
          onChange={onChange}
          steps={steps}
        />
      </div>
    </div>
  )

}

ReleaseNav.propTypes = {
  onChange: PropTypes.func,
  section: PropTypes.string,
  steps: PropTypes.array,
  type: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/release/components/ReleaseNav.js